export default {"src":"/_next/static/media/female_3.92ec56ec.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};